import React, { useState } from "react";
import DataTable from "react-data-table-component";
import PageSizeSelect from "components/PageSizeSelect/PageSizeSelect";
import Swal from "sweetalert2";
import {
  Button,
  Card,
  Form,
  Container,
  Row,
  Col,
  Tab,
  Modal,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import moment from "moment";
import { ColorRing, Dna, Watch } from "react-loader-spinner";
import { useDispatch, useSelector } from "react-redux";
import ReactPaginate from "react-paginate";
import { getAllKunjunganByLogin } from "stores/kunjungan/function";
import { updateApprovalKunjungan } from "stores";
import GoogleMapReact from "google-map-react";
import { exportPdfKunjungan } from "stores";
import { editFotoKunjungan } from "stores";
import { ajukanRevisiKunjungan } from "stores";
import { getExportKunjungan } from "stores";
import { showUrlDokumenKunjungan } from "stores";
import "./ListKunjungan.css";

function ListKunjungan() {
  const dispatch = useDispatch();
  const kunjungan = useSelector((state) => state.kunjunganReducer);
  const Korcab = useSelector((state) => state.korcabReducer);
  const auth = useSelector((state) => state.authReducer);
  const urlPreview = Korcab.urlDokumenKunjungan;
  const [listDataKunjungan, setListDataKunjungan] = React.useState([]);
  const [modalDetail, setModalDetail] = React.useState(false);
  const [modalRevisi, setModalRevisi] = React.useState(false);
  const [keterangan, setKeterangan] = React.useState("");
  const [namaNasabah, setNamaNasabah] = React.useState("");
  const [modalEditFoto, setModalEditFoto] = React.useState(false);
  const [isLoading, setIsLoading] = React.useState(true);
  const [totalPerHalaman, setTotalPerHalaman] = React.useState(10);
  const [page, setPage] = React.useState(0);
  const [buktiKunjungan, setBuktiKunjungan] = React.useState("");
  const [tampilFotoKunjungan, setTampilFotoKunjungan] = React.useState("");
  const [kirimFotoKunjungan, setKirimFotoKunjungan] = React.useState("");
  const [urlFoto, setUrlFoto] = React.useState("");
  const [idKunjungan, setIdKunjungan] = React.useState("");
  const [latitude, setLatitude] = useState(null);
  const [longitude, setLongitude] = useState(null);
  const [filterStatus, setFilterStatus] = React.useState(null);
  const [pilihOpsi, setPilihOpsi] = React.useState("");
  const [listStatus, setListStatus] = React.useState([]);
  const [searchText, setSearchText] = React.useState("");
  const [showUploadForm, setShowUploadForm] = React.useState(false);
  const [modalExport, setModalExport] = React.useState(false);
  const [tglAwal, setTglAwal] = React.useState("");
  const [tglAkhir, setTglAkhir] = React.useState("");
  const [selectedKeterangan, setSelectedKeterangan] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [loadingEditFoto, setLoadingEditFoto] = React.useState(false);
  const [modalKeteranganVisible, setModalKeteranganVisible] =
    React.useState(false);

  const handleKeteranganClick = (keterangan) => {
    setSelectedKeterangan(keterangan);
    setModalKeteranganVisible(true);
  };

  const handlePageSizeChange = (selectedOption) => {
    setTotalPerHalaman(selectedOption.value);
  };

  const handleAnimationComplete = () => {
    console.log("All letters have animated!");
  };

  const handleClick = (val) => {
    setModalDetail(!modalDetail);
    setLoading(true); // Mulai loading
    setTimeout(() => {
      setLoading(false);
    }, 2000);
    setBuktiKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      }),
    );
    setLatitude(parseFloat(val.lat));
    setLongitude(parseFloat(val.long));
  };

  const handleClickEditFoto = (val) => {
    setModalEditFoto(!modalEditFoto);
    setLoadingEditFoto(true); // Mulai loading
    setTimeout(() => {
      setLoadingEditFoto(false);
    }, 2000);
    setTampilFotoKunjungan(
      showUrlDokumenKunjungan(dispatch, {
        urlImage: val.buktiKunjungan,
      }),
    );
    setIdKunjungan(val._id);
    setUrlFoto(val.buktiKunjungan);
  };

  const handleFilterChange = () => {
    setIsLoading(true);
    getAllKunjunganByLogin(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false); // Setelah selesai memuat data
      })
      .catch((error) => {
        setIsLoading(false); // Jika terjadi error
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  };

  const submitAjukanRevisiKunjungan = () => {
    if (keterangan === "") {
      Swal.fire({
        title: "Keterangan Wajib Diisi",
        icon: "warning",
      });
      return;
    }

    Swal.fire({
      title: "Yakin ingin mengajukan revisi?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ajukan",
      cancelButtonText: "Batal",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });

        ajukanRevisiKunjungan({
          idKunjungan: idKunjungan,
          keterangan: keterangan,
        })
          .then((response) => {
            if (response.data.status === 200) {
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1000,
              });
              handleCloseModal();
              setModalRevisi(false);
              getAllKunjunganByLogin(dispatch, {
                page: page + 1,
                limit: totalPerHalaman,
                cari: searchText,
              });
            } else if (response.data.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.log("ERRORRRR", error);
            Swal.fire({
              icon: "error",
              title: "Terjadi kesalahan!",
              text: "Silakan coba lagi nanti.",
            });
          });
      }
    });
  };

  const submitExport = (e) => {
    e.preventDefault();
    // console.log(tglAwal, tglAkhir, status.value, "ASLKASDASDSAD");
    // if (status === "") {
    //   Swal.fire({
    //     title: "Status Harus Diisi",
    //     icon: "warning",
    //   });
    //   return;
    // }
    getExportKunjungan({
      tglAwal: tglAwal,
      tglAkhir: tglAkhir,
    });
  };

  // const submitAjukanRevisiKunjungan = () => {
  //   if (keterangan == "") {
  //     Swal.fire({
  //       title: "Keterangan Wajib Diisi",
  //       icon: "warning",
  //     });
  //     return;
  //   }
  //   ajukanRevisiKunjungan({
  //     idKunjungan: idKunjungan,
  //     keterangan: keterangan,
  //   })
  //     .then((response) => {
  //       if (response.data.status === 200) {
  //         Swal.fire({
  //           position: "center",
  //           icon: "success",
  //           title: response.data.message,
  //           showConfirmButton: false,
  //           timer: 1000,
  //         });
  //         handleCloseModal();
  //         setModalRevisi(false);
  //         getAllKunjunganByLogin(dispatch, {
  //           page: page + 1,
  //           limit: totalPerHalaman,
  //           cari: searchText,
  //         });
  //       } else if (response.data.status === 400) {
  //         Swal.fire({
  //           icon: "error",
  //           title: "Oops...",
  //           text: response.data.message,
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.log("ERRORRRR", error);
  //     });
  // };

  function submitEditFoto(e) {
    e.preventDefault();
    if (kirimFotoKunjungan === "") {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Foto tidak boleh kosong !",
      });
      return;
    }
    Swal.fire({
      title: "Konfirmasi",
      text: "Apakah Anda yakin ingin menyimpan perubahan?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Ya",
      cancelButtonText: "Tidak",
    }).then((result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Loading...",
          allowOutsideClick: false,
          showConfirmButton: false,
          onBeforeOpen: () => {
            Swal.showLoading();
          },
        });
        let dataToSend = new FormData();
        dataToSend.append("idKunjungan", idKunjungan);
        dataToSend.append("urlFoto", urlFoto);
        dataToSend.append("buktiKunjungan", kirimFotoKunjungan);

        editFotoKunjungan(dataToSend)
          .then((response) => {
            // console.log(response, "HHH");
            if (response.status === 200) {
              Swal.close();
              Swal.fire({
                position: "center",
                icon: "success",
                title: response.data.message,
                showConfirmButton: false,
                timer: 1500,
              });
              setModalEditFoto(false);

              // window.location.reload();
            } else if (response.status === 400) {
              Swal.fire({
                icon: "error",
                title: "Oops...",
                text: response.data.message,
              });
            }
          })
          .catch((error) => {
            console.error(error);
          });
      }
    });
  }

  React.useEffect(() => {
    let tmp =
      kunjungan.dataKunjungan.docs &&
      kunjungan.dataKunjungan.docs.map((val) => {
        const isDisabled =
          val.statusRevisi === true ||
          (auth.role === "client" &&
            (!val.approvalSupervisor || val.approvalKacap === true)) ||
          (auth.role === "supervisor" && val.approvalSupervisor) ||
          val.keputusan === "Ditolak";
        const isRevisiDisabled =
          (auth.role === "supervisor" &&
            (val.statusRevisi === true || val.approvalSupervisor === true)) ||
          (auth.role === "client" &&
            auth.jabatan === "korcab" &&
            auth.nopeg === "rizalrompis" &&
            auth.nopeg === "susansampangai" &&
            val.approvalSupervisor === false) ||
          val.statusRevisi === true;
        return {
          ...val,
          action: (
            <div className="action-buttons-group">
              <OverlayTrigger
                placement="top"
                overlay={<Tooltip>Detail</Tooltip>}
              >
                <Button
                  className="btn-action-custom btn-detail-blue"
                  aria-label="Detail kunjungan"
                  onClick={() => handleClick(val)}
                >
                  <i className="fas fa-info"></i>
                </Button>
              </OverlayTrigger>
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.role === "super admin" ||
                auth.role === "supervisor") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Approval Kunjungan Nasabah</Tooltip>}
                >
                  <Button
                    className="btn-action-custom btn-approve-green"
                    aria-label="Setujui kunjungan"
                    disabled={isDisabled}
                    onClick={async () => {
                      const loadingSwal = Swal.fire({
                        title: "Loading...",
                        allowOutsideClick: false,
                        showConfirmButton: false,
                        onBeforeOpen: () => {
                          Swal.showLoading();
                        },
                      });

                      try {
                        const result = await Swal.fire({
                          title: "Approve Kunjungan",
                          text: `Apakah anda yakin menyetujui ${val.calonNasabah ? val.calonNasabah.namaNasabah : ""} tersebut ?`,
                          icon: "warning",
                          showCancelButton: true,
                          confirmButtonColor: "#3085d6",
                          cancelButtonColor: "#d33",
                          confirmButtonText: "Ya",
                        });

                        if (result.isConfirmed) {
                          const response = await updateApprovalKunjungan({
                            idKunjungan: val._id,
                          });
                          loadingSwal.close();

                          Swal.fire({
                            title: "Sukses",
                            text: response.data.message,
                            icon: "success",
                            showConfirmButton: false,
                            timer: 2000,
                          });

                          getAllKunjunganByLogin(dispatch, {
                            page: page + 1,
                            limit: totalPerHalaman,
                            cari: searchText,
                          });
                        }
                      } catch (error) {
                        loadingSwal.close();
                        if (error.response && error.response.status === 400) {
                          Swal.fire({
                            title: "Error",
                            text: error.response.data.message,
                            icon: "error",
                            showConfirmButton: true,
                          });
                        }
                      }
                    }}
                  >
                    <i className="fas fa-check"></i>
                  </Button>
                </OverlayTrigger>
              )}
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.nopeg === "rizalrompis" ||
                auth.nopeg === "susansampangai") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Edit Foto</Tooltip>}
                >
                  <Button
                    className="btn-action-custom btn-edit-darkblue"
                    aria-label="Edit foto kunjungan"
                    onClick={() => handleClickEditFoto(val)}
                  >
                    <i className="fas fa-images"></i>
                  </Button>
                </OverlayTrigger>
              )}
              {((auth.role === "client" && auth.jabatan === "korcab") ||
                auth.nopeg === "rizalrompis" ||
                auth.nopeg === "susansampangai" ||
                auth.role === "supervisor") && (
                <OverlayTrigger
                  placement="top"
                  overlay={<Tooltip>Revisi Kunjungan</Tooltip>}
                >
                  <Button
                    className="btn-action-custom btn-revisi-grey"
                    aria-label="Revisi kunjungan"
                    disabled={isRevisiDisabled}
                    onClick={() => {
                      setModalRevisi(!modalRevisi);
                      setNamaNasabah(
                        val.calonNasabah ? val.calonNasabah.namaNasabah : "",
                      );
                      setIdKunjungan(val._id);
                    }}
                  >
                    <img
                      alt="..."
                      src={require("assets/img/revision.png")}
                      style={{ width: "16px", height: "16px" }}
                    />
                  </Button>
                </OverlayTrigger>
              )}
            </div>
          ),
        };
      });
    setListDataKunjungan(tmp);
  }, [kunjungan.dataKunjungan, auth]);

  const handleCloseModal = () => {
    setShowUploadForm(false);
    setKeterangan("");
  };

  const AnyReactComponent = ({ text }) => (
    <div style={{ color: "red", fontWeight: "bold" }}>
      <i className="fas fa-map-marker-alt"></i> {text}
    </div>
  );

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };

  const handleClearSearch = () => {
    setSearchText("");
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleFilterChange();
    }
  };

  React.useEffect(() => {
    let tmp = [
      {
        value: "Batal",
        label: "Batal",
      },

      {
        value: "Tunda",
        label: "Tunda",
      },
    ];
    setListStatus(tmp);
  }, [kunjungan.dataKunjungan, page, totalPerHalaman]);

  const defaultProps = {
    center: {
      lat: 0,
      lng: 0,
    },
    zoom: 11,
  };

  const options = [
    { value: 10, label: "10" },
    { value: 50, label: "50" },
    { value: 100, label: "100" },
  ];
  const KeteranganModal = () => (
    <Modal
      show={modalKeteranganVisible}
      onHide={() => setModalKeteranganVisible(false)}
    >
      <Modal.Header closeButton></Modal.Header>
      <Modal.Title
        style={{ textAlign: "center", fontWeight: "bolder", margin: 0 }}
      >
        Keterangan Lengkap
        <hr></hr>
      </Modal.Title>
      {/* <Modal.Body>{selectedKeterangan}</Modal.Body> */}
      <Card.Body>{selectedKeterangan}</Card.Body>
      {/* <Modal.Footer>
        <Button
          variant="secondary"
          onClick={() => setModalKeteranganVisible(false)}
        >
          Tutup
        </Button>
      </Modal.Footer> */}
    </Modal>
  );

  const getHasil = (hasilNasabah) => {
    switch (hasilNasabah) {
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Pinjam":
        return {
          fontWeight: "bold",
          backgroundColor: "#E3EEF9",
          textColor: "#1569C7",
        };
      case "Perhitungan Minus":
        return {
          fontWeight: "bold",
          backgroundColor: "#F2E6FF",
          textColor: "#7F00FF",
        };
      case "-":
        return {
          fontWeight: "bold",
          textColor: "#000000",
        };
      default:
        return {};
    }
  };
  const getStatusRevisi = (revisi) => {
    switch (revisi) {
      case true:
        return {
          fontWeight: "bold",
          backgroundColor: "#FBECEC",
          textColor: "#b42323",
        };
      case false:
        return {
          fontWeight: "bold",
          // backgroundColor: "#E6E6FF",
          // textColor: "#0000FF",
        };

      default:
        return {};
    }
  };

  const getKeputusan = (keputusan) => {
    switch (keputusan) {
      case "Tunda":
        return {
          fontWeight: "bold",
          backgroundColor: "#FFE6CC",
          textColor: "#FF7F00",
        };
      case "Batal":
        return {
          fontWeight: "bold",
          backgroundColor: "#F7DFE9",
          textColor: "#B0054B",
        };
      case "Disetujui":
        return {
          fontWeight: "bold",
          backgroundColor: "#E4F5C9",
          textColor: "#87CB16",
        };
      case "Ditolak":
        return {
          fontWeight: "bold",
          backgroundColor: "#FF0000",
          textColor: "#FFE6E6",
        };
      default:
        return {};
    }
  };

  const customStyles = {
    head: {
      style: { zIndex: 5 },
    },
    rows: {
      style: {
        minHeight: "68px",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headRow: {
      style: {
        minHeight: "56px",
        backgroundColor: "#f8fafc",
        borderBottom: "2px solid #e2e8f0",
        fontFamily: "Poppins, sans-serif",
      },
    },
    headCells: {
      style: {
        fontWeight: "700",
        fontSize: "12px",
        color: "#ffffff",
        textTransform: "uppercase",
        letterSpacing: "0.5px",
        paddingLeft: "16px",
        paddingRight: "16px",
      },
    },
    cells: {
      style: {
        fontSize: "13px",
        color: "#334155",
        padding: "14px 16px",
        lineHeight: "1.6",
      },
    },
  };

  const colKunjungan = [
    {
      id: "no",
      name: "No",
      width: "64px",
      center: true,
      // selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
      selector: (row, index) => index + kunjungan.dataKunjungan.pagingCounter,
    },
    {
      id: "nama-nasabah",
      name: "Nama Nasabah",
      width: "240px",
      wrap: true,
      style: { fontWeight: 600, color: "#0f172a" },
      selector: (row) =>
        !row.calonNasabah ? "-" : row.calonNasabah.namaNasabah,
    },
    {
      id: "nik",
      name: "NIK",
      width: "184px",
      center: true,
      style: { fontVariantNumeric: "tabular-nums" },
      selector: (row) => (!row.calonNasabah || !row.calonNasabah.nik ? "-" : row.calonNasabah.nik),
    },
    {
      name: "NIP",
      minWidth: "190px",
      center: true,
      style: { fontVariantNumeric: "tabular-nums" },
      selector: (row) => (!row.calonNasabah || !row.calonNasabah.nip ? "-" : row.calonNasabah.nip),
    },
    {
      name: "Tgl Kunjungan",
      minWidth: "180px",
      center: true,
      selector: (row) => moment(row.tglKunjungan).format("DD MMMM YYYY"),
    },
    {
      name: "Plafond",
      minWidth: "180px",
      right: true,
      style: { fontVariantNumeric: "tabular-nums", fontWeight: 600 },
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.plafond);
        return formattedValue;
      },
    },
    {
      name: "Nett",
      minWidth: "180px",
      right: true,
      style: { fontVariantNumeric: "tabular-nums", fontWeight: 600 },
      selector: (row) => {
        const formattedValue = new Intl.NumberFormat("id-ID", {
          style: "currency",
          currency: "IDR",
          minimumFractionDigits: 0,
        }).format(row.nett);
        return formattedValue;
      },
    },
    {
      name: "Keputusan",
      minWidth: "200px",
      center: true,
      selector: (row) => row.keputusan,
      cell: (row) => {
        let badgeClass = "badge-neutral";
        if (row.keputusan === "Disetujui") badgeClass = "badge-disetujui";
        else if (row.keputusan === "Ditolak") badgeClass = "badge-ditolak";
        else if (row.keputusan === "Tunda") badgeClass = "badge-tunda";
        else if (row.keputusan === "Batal") badgeClass = "badge-batal";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {row.keputusan || "-"}
          </span>
        );
      },
    },
    {
      name: "Hasil",
      minWidth: "200px",
      center: true,
      selector: (row) => row.hasil,
      cell: (row) => {
        const hasil =
          row.hasil === ""
            ? "-"
            : row.hasil === "Perhitungan minus"
              ? "Perhitungan Minus"
              : row.hasil;
        let badgeClass = "badge-neutral";
        if (hasil === "Batal") badgeClass = "badge-batal";
        else if (hasil === "Pinjam") badgeClass = "badge-pinjam";
        else if (hasil === "Perhitungan Minus") badgeClass = "badge-minus";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>{hasil}</span>
        );
      },
    },
    {
      name: "Cabang",
      minWidth: "250px",
      wrap: true,
      selector: (row) => (!row.cabang ? "-" : row.cabang.namaCabang),
    },
    {
      name: "Koordinator Cabang",
      minWidth: "250px",
      wrap: true,
      selector: (row) => (!row.korcab ? "-" : row.korcab.nama),
    },
    {
      name: "Marketing",
      minWidth: "250px",
      wrap: true,
      selector: (row) => (!row.marketing ? "-" : row.marketing.nama),
    },
    {
      name: "Supervisor",
      minWidth: "250px",
      wrap: true,
      selector: (row) => (!row.supervisor ? "-" : row.supervisor.nama),
    },
    {
      name: "Area Manager",
      minWidth: "250px",
      wrap: true,
      selector: (row) => (!row.areaManager ? "-" : row.areaManager.nama),
    },
    {
      name: "Status Revisi Kunjungan",
      minWidth: "250px",
      center: true,
      selector: (row) => row.statusRevisi,
      cell: (row) => {
        const tampilanLabel =
          row.statusRevisi === true ? "Sedang Direvisi" : "-";
        const badgeClass =
          row.statusRevisi === true ? "badge-ditolak" : "badge-neutral";
        return (
          <span className={`modern-badge-pill ${badgeClass}`}>
            {tampilanLabel}
          </span>
        );
      },
    },
    {
      name: "Revisi Dari",
      minWidth: "260px",
      center: true,
      selector: (row) =>
        row.revisiDari === "" ? "-" : !row.revisiDari ? "-" : row.revisiDari,
    },
    {
      name: "BAPLOAN",
      minWidth: "260px",
      center: true,
      selector: (row) =>
        row.bapLoan === "" ? "-" : !row.bapLoan ? "-" : row.bapLoan,
    },
    // {
    //   name: "Keterangan",
    //   minWidth: "300px",
    //   center: true,
    //   selector: (row) => (row.keterangan === "" ? "-" : row.keterangan),
    //   cell: (row) => {
    //     const maxLength = 20;
    //     const keterangan = row.keterangan || "-";
    //     const isLongText = keterangan.length > maxLength;
    //     const truncatedKeterangan = isLongText
    //       ? `${keterangan.substring(0, maxLength)}...`
    //       : keterangan;

    //     return (
    //       <>
    //         <div>{truncatedKeterangan}</div>
    //         {isLongText && (
    //           <div
    //             style={{ color: "blue", cursor: "pointer" }}
    //             onClick={() => handleKeteranganClick(keterangan)}
    //           >
    //             Selengkapnya
    //           </div>
    //         )}
    //       </>
    //     );
    //   },
    // },
    {
      name: "Keterangan",
      minWidth: "300px",
      wrap: true,
      selector: (row) => row.keterangan || "-",
    },
    {
      id: "aksi",
      name: "Aksi",
      width: "196px",
      center: true,
      cell: (row) => row.action,
    },
  ];

  // Full row width keeps frozen cells anchored throughout horizontal scrolling.
  customStyles.table = {
    style: {
      minWidth: listDataKunjungan?.length
        ? `${colKunjungan.reduce(
            (total, column) => total + parseInt(column.width || column.minWidth, 10),
            0,
          )}px`
        : "100%",
    },
  };

  React.useEffect(() => {
    setIsLoading(true);
    getAllKunjunganByLogin(dispatch, {
      page: page + 1,
      limit: totalPerHalaman,
      cari: searchText,
    })
      .then((response) => {
        setIsLoading(false); // Setelah selesai memuat data
      })
      .catch((error) => {
        setIsLoading(false); // Jika terjadi error
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Terjadi kesalahan saat memuat data.",
        });
      });
  }, [page, totalPerHalaman]);
  return (
    <>
      <Modal
        size="md"
        show={modalExport}
        onHide={() => {
          setModalExport(false);
          setTglAwal("");
          setTglAkhir("");
        }}
        centered
        className="modal-custom-detail"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{ fontWeight: "700", color: "#1e293b", fontSize: "18px" }}
          >
            Export Kunjungan
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitExport}>
            <Row>
              <Col sm="12" className="mb-3">
                <Form.Group>
                  <label className="text-muted small font-weight-bold text-uppercase">
                    Tanggal Awal
                  </label>
                  <Form.Control
                    onChange={(e) => {
                      setTglAwal(e.target.value);
                    }}
                    type="date"
                    required
                    style={{ borderRadius: "8px", height: "42px" }}
                  />
                </Form.Group>
              </Col>
              <Col sm="12" className="mb-4">
                <Form.Group>
                  <label className="text-muted small font-weight-bold text-uppercase">
                    Tanggal Akhir
                  </label>
                  <Form.Control
                    onChange={(e) => {
                      setTglAkhir(e.target.value);
                    }}
                    type="date"
                    required
                    style={{ borderRadius: "8px", height: "42px" }}
                  />
                </Form.Group>
              </Col>
            </Row>
            <div className="d-flex justify-content-end" style={{ gap: "10px" }}>
              <Button
                variant="link"
                className="text-muted font-weight-bold text-decoration-none"
                onClick={() => setModalExport(false)}
              >
                Batal
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#013E62",
                  borderColor: "#013E62",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  padding: "8px 20px",
                }}
              >
                Submit
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="md"
        show={modalRevisi}
        onHide={() => {
          setModalRevisi(false);
          handleCloseModal();
        }}
        centered
        className="modal-custom-detail"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{ fontWeight: "700", color: "#1e293b", fontSize: "18px" }}
          >
            Revisi Nasabah: {namaNasabah}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form.Group className="mb-4">
            <label className="text-muted small font-weight-bold text-uppercase">
              Keterangan Revisi
            </label>
            <Form.Control
              as="textarea"
              value={keterangan}
              onChange={(e) => {
                setKeterangan(e.target.value);
              }}
              rows={4}
              placeholder="Masukkan detail keterangan revisi..."
              style={{ borderRadius: "8px" }}
            />
          </Form.Group>
          <div className="d-flex justify-content-end" style={{ gap: "10px" }}>
            <Button
              variant="link"
              className="text-muted font-weight-bold text-decoration-none"
              onClick={() => {
                setModalRevisi(false);
                handleCloseModal();
              }}
            >
              Batal
            </Button>
            <Button
              type="button"
              onClick={submitAjukanRevisiKunjungan}
              style={{
                backgroundColor: "#b42323",
                borderColor: "#b42323",
                fontWeight: "bold",
                borderRadius: "8px",
                padding: "8px 20px",
              }}
            >
              Submit
            </Button>
          </div>
        </Modal.Body>
      </Modal>

      <Modal
        size="lg"
        show={modalEditFoto}
        onHide={() => {
          setModalEditFoto(false);
          handleCloseModal();
        }}
        centered
        className="modal-custom-detail"
      >
        <Modal.Header closeButton>
          <div className="d-flex w-100 justify-content-between align-items-center pr-3">
            <Modal.Title
              style={{ fontWeight: "700", color: "#1e293b", fontSize: "20px" }}
            >
              Edit Foto Kunjungan
            </Modal.Title>
            <Button
              onClick={() => setShowUploadForm((prev) => !prev)}
              style={{
                backgroundColor: "#013E62",
                borderColor: "#013E62",
                fontWeight: "bold",
                borderRadius: "8px",
                padding: "6px 14px",
                fontSize: "13px",
              }}
            >
              {showUploadForm ? "Tutup Form Upload" : "Pilih File Baru"}
            </Button>
          </div>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={submitEditFoto}>
            {showUploadForm && (
              <div
                className="mb-4 p-3"
                style={{
                  background: "#f8fafc",
                  borderRadius: "10px",
                  border: "1px solid #e2e8f0",
                }}
              >
                <Form.Group className="mb-0">
                  <label className="text-muted small font-weight-bold text-uppercase d-block mb-2">
                    Pilih File Foto Kunjungan
                  </label>
                  <Form.Control
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={(e) => {
                      setKirimFotoKunjungan(e.target.files[0]);
                    }}
                    style={{ borderRadius: "8px" }}
                  />
                  <small className="text-muted d-block mt-2">
                    Format file yang didukung:{" "}
                    <strong>.png, .jpg, .jpeg</strong>
                  </small>
                </Form.Group>
              </div>
            )}

            <div className="detail-image-wrapper mb-4">
              {tampilFotoKunjungan ? (
                loadingEditFoto ? (
                  <div className="d-flex flex-column align-items-center justify-content-center">
                    <ColorRing
                      visible={true}
                      height="60"
                      width="60"
                      colors={[
                        "#64748b",
                        "#64748b",
                        "#64748b",
                        "#64748b",
                        "#64748b",
                      ]}
                    />
                    <span className="text-muted mt-2 small">
                      Memuat foto...
                    </span>
                  </div>
                ) : (
                  <img
                    src={urlPreview}
                    alt="Bukti Kunjungan"
                    className="detail-image"
                  />
                )
              ) : (
                <div className="text-center p-4">
                  <div
                    className="alert alert-warning border-0 text-warning font-weight-bold mb-3"
                    style={{ background: "#fffbeb", borderRadius: "8px" }}
                  >
                    Maaf, masih belum ada bukti Kunjungan untuk saat ini..
                  </div>
                  <img
                    src={require("assets/img/sorry.jpg")}
                    alt="Sorry"
                    style={{ maxWidth: "250px", borderRadius: "8px" }}
                  />
                </div>
              )}
            </div>

            <div className="d-flex justify-content-end" style={{ gap: "10px" }}>
              <Button
                variant="link"
                className="text-muted font-weight-bold text-decoration-none"
                onClick={() => {
                  setModalEditFoto(false);
                  handleCloseModal();
                }}
              >
                Batal
              </Button>
              <Button
                type="submit"
                style={{
                  backgroundColor: "#013E62",
                  borderColor: "#013E62",
                  fontWeight: "bold",
                  borderRadius: "8px",
                  padding: "8px 24px",
                }}
              >
                Simpan Perubahan
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>

      <Modal
        size="xl"
        show={modalDetail}
        onHide={() => setModalDetail(!modalDetail)}
        centered
        className="modal-custom-detail"
      >
        <Modal.Header closeButton>
          <Modal.Title
            style={{ fontWeight: "700", color: "#1e293b", fontSize: "20px" }}
          >
            Detail Kunjungan & Lokasi
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Row>
            {/* Kolom Bukti Kunjungan */}
            <Col xs={12} lg={6} className="mb-4 mb-lg-0">
              <div className="detail-section-title">
                <i className="fas fa-camera"></i> Bukti Kunjungan
              </div>
              <div className="detail-image-wrapper">
                {buktiKunjungan ? (
                  loading ? (
                    <div className="d-flex flex-column align-items-center justify-content-center">
                      <ColorRing
                        visible={true}
                        height="60"
                        width="60"
                        colors={[
                          "#3b82f6",
                          "#3b82f6",
                          "#3b82f6",
                          "#3b82f6",
                          "#3b82f6",
                        ]}
                      />
                      <span className="text-muted mt-2 small">
                        Memuat gambar...
                      </span>
                    </div>
                  ) : (
                    <img
                      src={urlPreview}
                      alt="Bukti Kunjungan"
                      className="detail-image"
                    />
                  )
                ) : (
                  <div className="text-center p-4">
                    <div
                      className="alert alert-warning border-0 text-warning font-weight-bold mb-3"
                      style={{ background: "#fffbeb", borderRadius: "8px" }}
                    >
                      Maaf, masih belum ada bukti Kunjungan untuk saat ini..
                    </div>
                    <img
                      src={require("assets/img/sorry.jpg")}
                      alt="Sorry"
                      style={{ maxWidth: "250px", borderRadius: "8px" }}
                    />
                  </div>
                )}
              </div>
            </Col>

            {/* Kolom Peta Lokasi */}
            <Col xs={12} lg={6}>
              <div className="detail-section-title">
                <i className="fas fa-map-marked-alt"></i> Lokasi GPS
              </div>
              <div className="detail-map-wrapper">
                <GoogleMapReact
                  bootstrapURLKeys={{
                    key: "AIzaSyDEQbFkmNjBsVFEHW_pLszpxLNOXr5HLYk",
                  }}
                  center={{
                    lat: latitude || defaultProps.center.lat,
                    lng: longitude || defaultProps.center.lng,
                  }}
                  defaultZoom={defaultProps.zoom}
                >
                  {latitude !== null && longitude !== null && (
                    <AnyReactComponent lat={latitude} lng={longitude} />
                  )}
                </GoogleMapReact>
              </div>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Container fluid>
        <Row>
          <Col md="12">
            <Card className="kunjungan-card">
              <Card.Header className="kunjungan-card-header">
                <div className="d-flex flex-column flex-md-row justify-content-between align-items-md-center">
                  <div>
                    <Card.Title as="h3" className="kunjungan-title">
                      Daftar Kunjungan Nasabah
                    </Card.Title>
                    <div className="kunjungan-subtitle">
                      Kelola dan verifikasi seluruh kunjungan nasabah secara
                      real-time
                    </div>
                  </div>
                  <div
                    className="mt-3 mt-md-0 d-flex flex-wrap align-items-center"
                    style={{ gap: "12px" }}
                  >
                    {/* Search and filter group */}
                    <div style={{ minWidth: "260px" }}>
                      <InputGroup className="search-input-group">
                        <Form.Control
                          className="search-input-control"
                          type="text"
                          value={searchText}
                          onChange={handleSearch}
                          placeholder="Nama Nasabah / NIP..."
                          onKeyDown={handleKeyDown}
                        />
                        {searchText && (
                          <InputGroup.Append>
                            <Button
                              className="search-clear-btn"
                              onClick={handleClearSearch}
                            >
                              <i className="fas fa-times"></i>
                            </Button>
                          </InputGroup.Append>
                        )}
                        <InputGroup.Append>
                          <Button
                            className="search-submit-btn"
                            onClick={handleFilterChange}
                          >
                            <i className="fas fa-search"></i>
                          </Button>
                        </InputGroup.Append>
                      </InputGroup>
                    </div>

                    <Button
                      className="btn-export-kunjungan"
                      onClick={() => {
                        setModalExport(true);
                      }}
                    >
                      Export Kunjungan
                      <img
                        alt="..."
                        src={require("assets/img/excel1.png")}
                        style={{
                          width: "18px",
                          height: "20px",
                        }}
                      />
                    </Button>
                  </div>
                </div>
              </Card.Header>
              <Card.Body>
                {isLoading ? (
                  <div
                    className="loader-container"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      alignItems: "center",
                      justifyContent: "center",
                      height: "30vh",
                    }}
                  >
                    <Watch
                      visible={true}
                      height="80"
                      width="80"
                      radius="30"
                      color="#F75D59"
                      ariaLabel="watch-loading"
                      wrapperStyle={{}}
                      wrapperClass=""
                    />
                    <p className="text-muted mt-3">Memuat data kunjungan...</p>
                  </div>
                ) : (
                  <div>
                    <div className="kunjungan-table-summary">
                      <div>
                        <span className="kunjungan-table-summary-title">
                          Monitoring Kunjungan
                        </span>
                        <span className="kunjungan-table-count">
                          {listDataKunjungan?.length || 0} data di halaman ini
                        </span>
                      </div>
                      <span className="kunjungan-table-hint">
                        <i className="fas fa-arrows-alt-h" aria-hidden="true" />
                        Geser tabel untuk melihat detail lainnya
                      </span>
                    </div>
                    <div className="kunjungan-table-frame">
                      <DataTable
                        className="kunjungan-monitoring-table"
                        keyField="_id"
                        columns={colKunjungan}
                        data={listDataKunjungan || []}
                        customStyles={customStyles}
                        fixedHeader
                        fixedHeaderScrollHeight="65vh"
                        noDataComponent={
                          <div className="kunjungan-table-empty">
                            Belum ada data kunjungan yang sesuai dengan pencarian.
                          </div>
                        }
                        paginationPerPage={totalPerHalaman}
                      />
                    </div>
                    {modalKeteranganVisible && <KeteranganModal />}
                    <div style={{ marginTop: 35 }}>
                      <Row className="align-items-center">
                        <Col
                          xs={12}
                          md={6}
                          className="d-flex align-items-center justify-content-center justify-content-md-start mb-3 mb-md-0"
                        >
                          <span
                            style={{
                              fontWeight: "700",
                              color: "#64748b",
                              fontSize: "14px",
                              marginRight: "12px",
                            }}
                          >
                            Baris per halaman:
                          </span>
                          <div style={{ width: "110px" }}>
                            <PageSizeSelect
                              value={totalPerHalaman}
                              options={options}
                              onChange={handlePageSizeChange}
                            />
                          </div>
                        </Col>

                        <Col
                          xs={12}
                          md={6}
                          className="d-flex justify-content-center justify-content-md-end"
                        >
                          <ReactPaginate
                            forcePage={page}
                            containerClassName="paginations"
                            previousClassName="pages-itemss-containers"
                            previousLinkClassName="pages-links-labelss"
                            nextClassName="pages-itemss-containers"
                            nextLinkClassName="pages-links-labelss"
                            breakClassName="pages-itemss-containers"
                            pageCount={kunjungan.dataKunjungan.totalPages || 1}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={1}
                            pageLinkClassName="pages-links-labelss"
                            pageClassName="pages-itemss-containers"
                            activeClassName="activees"
                            activeLinkClassName="aactivess"
                            nextLabel=" > "
                            previousLabel=" < "
                            initialPage={page}
                            disableInitialCallback={true}
                            onPageChange={(val) => {
                              setPage(val.selected);
                            }}
                          />
                        </Col>
                      </Row>
                    </div>
                  </div>
                )}
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default ListKunjungan;
